import { Close } from "@lazarentertainment/web-design-system/components/iconOutline"
import { useLayoutContext } from "client/components/layout"
import { Button } from "client/designSystem/Button"
import { Sheet } from "client/designSystem/Sheet"
import { Voting_Question } from "client/graphql"
import { useVideoContext } from "client/packages/player/player/VideoContext"
import {
  Plugin,
  useGlobalContext,
} from "client/packages/utils/GlobalContext"
import { useEffect, useState } from "react"

import Question from "./Question"
import { useVotingContext } from "./VotingContext"

import styles from "./votingMobileSheet.module.css"

/*
 * Helper: tracks the 'mostRecent' voting question/answer,
 * So the contents of the voting sheet don't disappear during the closing animation.
 */
const useMostRecentQuestionAndAnswer = (
  question: Voting_Question,
  answerId: string,
): [Voting_Question, string] => {
  const [mostRecentQuestion, setMostRecentQuestion] =
    useState<Voting_Question | null>(question)
  const [mostRecentAnswerId, setMostRecentAnswerId] = useState<
    string | null
  >(answerId)

  useEffect(() => {
    // If the question is null/gone, KEEP our 'mostRecent' stuff.
    // If a new question shows up, reset our 'mostRecent' stuff
    if (question && question.id !== mostRecentQuestion?.id) {
      setMostRecentQuestion(question)
      setMostRecentAnswerId(null)
    }
  }, [question])
  useEffect(() => {
    if (answerId) {
      setMostRecentAnswerId(answerId)
    }
  }, [answerId])

  return [mostRecentQuestion, mostRecentAnswerId]
}

export const VotingMobileSheet = () => {
  const {
    state: { isVotingPluginOpen },
  } = useGlobalContext()
  const { layout } = useLayoutContext()
  const { setPluginOpen } = useGlobalContext()
  const { activeQuestion, selectedAnswerId } = useVotingContext()
  const { alreadyPlayed } = useVideoContext()

  const [mostRecentQuestion, mostRecentAnswerId] =
    useMostRecentQuestionAndAnswer(activeQuestion, selectedAnswerId)

  return (
    <Sheet
      className={styles.votingMobileSheet}
      open={alreadyPlayed && isVotingPluginOpen}
      data-layout={layout}
      title={mostRecentQuestion.text}
      topRightContent={
        <Button
          variant="tertiary-gray"
          iconOnly
          icon={Close}
          onClick={() => {
            setPluginOpen(Plugin.VOTING, false)
          }}
          data-robot="voting-close"
        />
      }
    >
      {mostRecentQuestion && (
        <Question
          question={mostRecentQuestion}
          selectedAnswerId={mostRecentAnswerId}
        />
      )}
    </Sheet>
  )
}
